import React from 'react'

const CrossIcon = () => {
    return (
        <div className='unverified_icon'>
            <div className="icon-cross"></div>
        </div>
    )
}

export default CrossIcon